<div class="days-list-component d-flex flex-column">
    <div class="days-list-header mb-4 d-flex flex-column">
        <div *ngIf="availabilityLabelText" class="availability-label d-flex align-items-center py-1">
            <div class="green-circle rounded-circle bg-success me-3"></div>
            <span>{{ availabilityLabelText }}</span>
        </div>

        <button
            type="button"
            class="days-list-calendar-btn btn border-0 px-2 py-1 align-self-center"
            autoClose="outside"
            [ngbPopover]="customCalendar"
            placement="bottom auto"
            popoverClass="custom-multiviewcalendar-popover popover-no-arrow"
            title="{{  calendarDateTitle  | date }}"
            triggers="manual"
            #popOver="ngbPopover"
            (click)="popOver.open()"
        >
            <span>{{ calendarDateTitle | date: "MMMM yyyy" | uppercase }}</span>

            <i class="arrow-icon app-icon icon icon-chevron-down icon-md ms-2"></i>
        </button>

        <ng-template #customCalendar>
            <kendo-multiviewcalendar
                class="custom-multiviewcalendar"
                [(value)]="value"
                (valueChange)="onCalendarDateChange($event)"
                (click)="onCalendarClick($event)"    
                [disabledDates]="calendarDisabledDates" 
                [showOtherMonthDays]="false"
            >
                <kendo-multiviewcalendar-messages today="{{calendarLabelToday}}">
                </kendo-multiviewcalendar-messages>
            </kendo-multiviewcalendar>
        </ng-template>
    </div>

    <div class="days-list-box d-flex align-items-center justify-content-center">
        <button type="button" [disabled] = "daysList[0].date <= today" [ngClass]="{'is-disabled' : daysList[0].date <= today}"
            class="btn p-2 days-list-arrow-btn btn-prev text-secondary"
            (click)="onDaysListScroll(false)"
        >
            <i class="app-icon icon icon-chevron-left icon-md"></i>
        </button>

        <div class="days-list flex-grow-1 d-flex align-items-center justify-content-around">
            <button type="button" *ngFor="let day of daysList; let dayIndex = index"
                class="btn day-btn rounded-full p-2 gap-3"
                [disabled] = "!day.isAvailable"
                [ngClass]="{
                    'current-day': day.date.getTime() === today.getTime(),
                    'selected-day': value && day.date.getTime() === value.getTime() && ((day.date.getTime() !== today.getTime() && !day.isAvailable) || day.isAvailable),
                    'available-day': value && day.isAvailable && day.date.getTime() !== value.getTime(),
                    'is-disabled disabled-day text-main bg-white': !day.isAvailable && day.date.getTime() !== today.getTime()
                }"
                (click)="onDayChange(day.date)"
            >
                <span class="date-value">{{ day.date | date: "dd" }}</span>
                <span class="day-value"
                    [ngClass]="{
                        'text-secondary': !day.isAvailable && day.date.getTime() !== today.getTime()
                    }"
                >
                    {{ day.date | date: "EE" }}
                </span>
            </button>
        </div>

        <button type="button"
            class="btn p-2 days-list-arrow-btn btn-next text-secondary"
            (click)="onDaysListScroll(true)"
        >
            <i class="app-icon icon icon-chevron-right icon-md"></i>
        </button>
    </div>
</div>
